import { callApp } from "@socar-inc/web-frontend-libraries";
import { useEffect } from "react";

export interface UseActionBarProps {
  visible?: Boolean;
  backFunction?: { value: string };
  title?: string;
  retentionSite?: string[];
  dependencies?: unknown[];
}

export const useActionBar = ({
  visible,
  backFunction,
  title,
  retentionSite = [],
  dependencies = []
}: UseActionBarProps = {}) => {
  useEffect(() => {
    callApp("ActionBar", {
      visible,
      backFunction,
      title,
      retentionSite: [location.origin, ...retentionSite]
    });
  }, [...dependencies]);
};
